import { API_URL } from '../../constants';
import { Streamingpackage } from '../../interfaces/StreamingProvider.interface';

export const getStreamingPackage = async (): Promise<Streamingpackage[]> => {
  try {
    const response = await fetch(API_URL + '/api/streamingpackage');
    if (!response.ok) {
      throw new Error('Error fetching streamingpackages');
    }

    const Streamingpackages: Streamingpackage[] = await response.json();

    return Streamingpackages;
  } catch (error) {
    console.error('Error fetching streamingpackages:', error);
    return [];
  }
};
